import {
  ActionButton,
  BioLink,
  BioLinks,
  BioText,
  Content,
  Description,
  PersonBio,
  PersonImageWrapper,
  PersonWrapper,
  Section,
  Title,
} from './joinUsCareers.styles';
import React from 'react';
import Image from 'next/image';
import { imageSerializer } from 'utils/imageSerializer';
import { IJoinUsCareers } from './interfaces';
import { formatPhoneNumber } from '../../../utils/phoneNumberFormatter';

export const JoinUsCareers = ({
  title,
  description,
  actionLabel,
  actionLink,
  id,
  titleAs,
  joinUsText,
  joinUsPhone,
  joinUsMail,
  joinUsImage,
}: IJoinUsCareers): JSX.Element => {
  return (
    <Section id={id && id}>
      <Content>
        <Title as={titleAs && titleAs}>{title}</Title>
        <Description>{description}</Description>
        <ActionButton href={actionLink}>{actionLabel}</ActionButton>
      </Content>
      <PersonWrapper>
        <PersonImageWrapper>
          <Image {...imageSerializer(joinUsImage)} />
        </PersonImageWrapper>
        <PersonBio>
          <BioText>{joinUsText}</BioText>
          <BioLinks>
            <BioLink href={`tel:${joinUsPhone}`}>
              {formatPhoneNumber(joinUsPhone)}
            </BioLink>
            <BioLink href={`mailto:${joinUsMail}`}>{joinUsMail}</BioLink>
          </BioLinks>
        </PersonBio>
      </PersonWrapper>
    </Section>
  );
};
